import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "contentment"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "ratio"
};
const _hoisted_4 = {
  class: "town"
};
const _hoisted_5 = {
  class: "school"
};
import { ref, watch } from 'vue';
import CardHeader from './CardHeader.vue';
import { useSeamlessScroll } from '@/hooks/useSeamlessScroll.js';
export default {
  __name: 'ContentmentList',
  props: {
    evaluationList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  setup(__props) {
    let scrollStyle = ref({});
    let props = __props;
    let dataList = ref();
    watch(() => props.evaluationList, newValue => {
      if (newValue?.length > 5) {
        dataList.value = [...newValue, ...newValue];
        let {
          scrollStyle
        } = useSeamlessScroll(45, newValue.length);
        scrollStyle.value = scrollStyle;
      } else {
        dataList.value = [...newValue];
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CardHeader, {
        title: "满意度调查"
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "list",
        style: _normalizeStyle(_unref(scrollStyle))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [_createVNode(_component_el_image, {
          class: "icon",
          fit: "fill",
          src: require('@/assets/images/screen/contentment-icon.png')
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_3, _toDisplayString(item.ratio) + "%", 1), _createElementVNode("div", _hoisted_4, _toDisplayString(item.cityName), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.companyName), 1)]);
      }), 128))], 4)])]);
    };
  }
};